import { ordersUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'
import loginStorage from '../storage/login'

async function getCurrentOrders() {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${ordersUrl}/GetCurrentOrdersByRestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.orders });
    return data;
}

async function getCurrentOrdersByRestaurantOwner() {
    let id = loginStorage.getRestaurantOwnerId();
    let url = `${ordersUrl}/GetCurrentOrdersByRestaurantOwner/${id}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.restaurants });
    return data;
}

async function getOrdersByDateAndRestaurant(createdDate) {
    let id = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${ordersUrl}/getordersbydateandrestaurant/${id}/${createdDate}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.orders });
    return data;
}



export default {
    name: 'ordersService',
    getCurrentOrders,
    getCurrentOrdersByRestaurantOwner,
    getOrdersByDateAndRestaurant
}